import { lazy } from "react";
import { createRoot } from "react-dom/client";
import { addTranslation } from "@/utils/i18n";
import { zodUnsafeValidate } from "@/utils/zod";
import { RequestDemo } from "./types";

const RequestDemoDialog = lazy(() =>
  import("./RequestDemoDialog").then((m) => ({
    default: m.RequestDemoDialog,
  })),
);

export const createRequestDemoDialogTrigger = () => {
  if (window.requestDemoConfig !== undefined) {
    const buttons = document.querySelectorAll("[data-request-demo-btn]");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        createRequestDemoDialog();
      });
    });
  }
};

export const createRequestDemoDialog = () => {
  if (window.requestDemoConfig !== undefined) {
    const config = zodUnsafeValidate(
      RequestDemo.ConfigSchema,
      window.requestDemoConfig,
    );

    addTranslation(config.translation);

    const container = document.createElement("div");
    const root = createRoot(container);

    root.render(
      <RequestDemoDialog
        config={config}
        onClose={() => {
          root.unmount();
          container.remove();
        }}
      />,
    );
  }
};
